<template>
	<v-dialog v-model="dialog" persistent max-width="500px">
		<v-card>
			<v-form>
				<v-toolbar flat dense cad>
					<v-toolbar-title class="subheading">{{ title }}</v-toolbar-title>
					<v-spacer></v-spacer>
				</v-toolbar>

				<v-divider></v-divider>
				<v-card-text>
					<v-text-field v-model="form.text" :error-messages="textErrors" label="Text" required @input="$v.form.text.$touch()" @blur="$v.form.text.$touch()"></v-text-field>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn flat @click="closeEditor">Cancel</v-btn>
					<v-btn color="primary" flat @click="submit">Save</v-btn>
				</v-card-actions>
			</v-form>
		</v-card>
	</v-dialog>
</template>

<script>
	import { validationMixin } from 'vuelidate';
	import { required } from 'vuelidate/lib/validators';

	export default {
		props: {
			category: {
				type: Object,
				default: () => ({
					id: null,
					text: null
				})
			},
			dialog: {},
			title: {
				required: true,
				type: String
			}
		},
		data() {
			return {
				form: {
					id: this.category.id,
					text: this.category.text
				}
			};
		},
		watch: {
			category() {
				this.form = {
					id: this.category.id,
					text: this.category.text
				};
			}
		},
		computed: {
			textErrors() {
				const errors = [];
				if (!this.$v.form.text.$dirty) return errors;
				!this.$v.form.text.required && errors.push('Text is required.');
				return errors;
			}
		},
		mixins: [validationMixin],

		validations: {
			form: {
				text: { required }
			}
		},
		methods: {
			submit() {
				this.$v.form.$touch();

				if (this.$v.form.$invalid) {
					console.log('invalid form');
				} else {
					let postObj = {
						id: this.form.id != undefined ? this.form.id : null,
						text: this.form.text
					};
					this.$emit('save', postObj);
					this.closeEditor();
				}
			},
			closeEditor() {
				this.clear();
				this.$emit('closeEditor');
			},
			clear() {
				this.$v.form.$reset();
				this.form = {
					id: null,
					text: null
				};
			}
		}
	};
</script>

<style></style>
